exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icp__input[data-v-af0fcaac] {\n  border-radius: 4px;\n  background-color: #000 !important;\n}\n.mt-2[data-v-af0fcaac] {\n  margin-top: 10px;\n}\n", ""]);

// exports
